import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MixedLoyaltyQuery, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { OwlCarouselSettings } from '@fgb/portal-component-library/src/lib/shared/utilities';
import { map } from 'rxjs/operators';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { WalletRedeemListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/wallet/wallet-redeem-list-item';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from 'ngx-owl-carousel-o';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/loyalty/wallet/wallet-redeem-list-item';
import * as ɵngcc5 from '@ngx-translate/core';

function WalletRedeemListComponent_ng_container_2_div_1_ng_container_8_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "fgbcl-wallet-redeem-list-item", 8);
} if (rf & 2) {
    const item_r4 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("item", item_r4)("ignoreLink", ctx_r5.isDragging)("dateOption", ctx_r5.dateOption);
} }
function WalletRedeemListComponent_ng_container_2_div_1_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, WalletRedeemListComponent_ng_container_2_div_1_ng_container_8_ng_template_1_Template, 1, 3, "ng-template", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("width", 300);
} }
function WalletRedeemListComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "h2", 3);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "owl-carousel-o", 5);
    ɵngcc0.ɵɵlistener("dragging", function WalletRedeemListComponent_ng_container_2_div_1_Template_owl_carousel_o_dragging_7_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.isDragging = $event.dragging; });
    ɵngcc0.ɵɵtemplate(8, WalletRedeemListComponent_ng_container_2_div_1_ng_container_8_Template, 2, 1, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const mixedLoyaltyWalletList_r1 = ɵngcc0.ɵɵnextContext().ngIf;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 4, "wallet.redeem.title"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 6, "wallet.redeem.info"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("options", ctx_r2.customOptions);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", mixedLoyaltyWalletList_r1);
} }
function WalletRedeemListComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, WalletRedeemListComponent_ng_container_2_div_1_Template, 9, 8, "div", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const mixedLoyaltyWalletList_r1 = ctx.ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", mixedLoyaltyWalletList_r1.length);
} }
class WalletRedeemListComponent {
    constructor(mixedLoyaltyQuery) {
        this.mixedLoyaltyQuery = mixedLoyaltyQuery;
        this.onlyRedeemed = false;
        this.marketplaceFilterTypes = [0, 1, 2, 3, 4, 5];
        this.dateOption = {
            LongDateFormat: 'd/M/yy h:mma',
            ShortDateFormat: 'MMM d, yyyy',
        };
        this.isDragging = false;
        this.customOptions = {
            margin: OwlCarouselSettings.Margin,
            autoWidth: true,
            pullDrag: false,
            autoplay: OwlCarouselSettings.Autoplay,
            autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
            autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
            navSpeed: 700,
            navText: ['', ''],
            responsive: {
                0: { items: 1 },
                540: { items: 2 },
                740: { items: 3 },
            },
        };
    }
    ngOnInit() {
        this.mixedLoyaltyWalletList$ = this.mixedLoyaltyQuery
            .selectMixedLoyaltyWalletItems(this.onlyRedeemed, this.marketplaceFilterTypes)
            .pipe(map((items) => items.slice(0, this.take)));
    }
}
WalletRedeemListComponent.ɵfac = function WalletRedeemListComponent_Factory(t) { return new (t || WalletRedeemListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.MixedLoyaltyQuery)); };
WalletRedeemListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: WalletRedeemListComponent, selectors: [["fgbcl-wallet-redeem-list"]], inputs: { onlyRedeemed: "onlyRedeemed", marketplaceFilterTypes: "marketplaceFilterTypes", dateOption: "dateOption", take: "take" }, decls: 4, vars: 3, consts: [[1, "wallet-redeem-carousel", "bg-wallet-redeem", "pb-3", "pt-4"], [1, "container"], [4, "ngIf"], [1, "mb-2", "mt-0", "wallet-redeem-title"], [1, "d-none", "d-lg-block", "mb-2", "wallet-redeem-info"], [3, "options", "dragging"], [4, "ngFor", "ngForOf"], ["carouselSlide", "", 3, "width"], [3, "item", "ignoreLink", "dateOption"]], template: function WalletRedeemListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, WalletRedeemListComponent_ng_container_2_Template, 2, 1, "ng-container", 2);
        ɵngcc0.ɵɵpipe(3, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(3, 1, ctx.mixedLoyaltyWalletList$));
    } }, directives: [ɵngcc2.NgIf, ɵngcc3.CarouselComponent, ɵngcc2.NgForOf, ɵngcc3.CarouselSlideDirective, ɵngcc4.WalletRedeemListItemComponent], pipes: [ɵngcc2.AsyncPipe, ɵngcc5.TranslatePipe], styles: [""] });
WalletRedeemListComponent.ctorParameters = () => [
    { type: MixedLoyaltyQuery }
];
WalletRedeemListComponent.propDecorators = {
    onlyRedeemed: [{ type: Input }],
    marketplaceFilterTypes: [{ type: Input }],
    take: [{ type: Input }],
    dateOption: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WalletRedeemListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-wallet-redeem-list',
                template: "<div class=\"wallet-redeem-carousel bg-wallet-redeem pb-3 pt-4\">\r\n  <div class=\"container\">\r\n    <ng-container *ngIf=\"mixedLoyaltyWalletList$ | async as mixedLoyaltyWalletList\">\r\n      <div *ngIf=\"mixedLoyaltyWalletList.length\">\r\n        <h2 class=\"mb-2 mt-0 wallet-redeem-title\">{{ 'wallet.redeem.title' | translate }}</h2>\r\n        <div class=\"d-none d-lg-block mb-2 wallet-redeem-info\">{{ 'wallet.redeem.info' | translate }}</div>\r\n        <owl-carousel-o [options]=\"customOptions\" (dragging)=\"isDragging = $event.dragging\">\r\n          <ng-container *ngFor=\"let item of mixedLoyaltyWalletList\">\r\n            <ng-template carouselSlide [width]=\"300\">\r\n              <fgbcl-wallet-redeem-list-item\r\n                [item]=\"item\"\r\n                [ignoreLink]=\"isDragging\"\r\n                [dateOption]=\"dateOption\"\r\n              ></fgbcl-wallet-redeem-list-item>\r\n            </ng-template>\r\n          </ng-container>\r\n        </owl-carousel-o>\r\n      </div>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.MixedLoyaltyQuery }]; }, { onlyRedeemed: [{
            type: Input
        }], marketplaceFilterTypes: [{
            type: Input
        }], dateOption: [{
            type: Input
        }], take: [{
            type: Input
        }] }); })();

class WalletRedeemListModule {
}
WalletRedeemListModule.ɵfac = function WalletRedeemListModule_Factory(t) { return new (t || WalletRedeemListModule)(); };
WalletRedeemListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: WalletRedeemListModule });
WalletRedeemListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CarouselModule,
            WalletRedeemListItemModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(WalletRedeemListModule, { declarations: function () { return [WalletRedeemListComponent]; }, imports: function () { return [CommonModule,
        CarouselModule,
        WalletRedeemListItemModule, ɵngcc5.TranslateModule]; }, exports: function () { return [WalletRedeemListComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WalletRedeemListModule, [{
        type: NgModule,
        args: [{
                declarations: [WalletRedeemListComponent],
                imports: [
                    CommonModule,
                    CarouselModule,
                    WalletRedeemListItemModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [WalletRedeemListComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { WalletRedeemListComponent, WalletRedeemListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-wallet-wallet-redeem-list.js.map